import { render, staticRenderFns } from "./PayrollCorrectionNotice.vue?vue&type=template&id=77bd2721&scoped=true&"
import script from "./PayrollCorrectionNotice.vue?vue&type=script&lang=js&"
export * from "./PayrollCorrectionNotice.vue?vue&type=script&lang=js&"
import style0 from "./PayrollCorrectionNotice.vue?vue&type=style&index=0&id=77bd2721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd2721",
  null
  
)

export default component.exports